export const styles = {
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  smMargin: {
    margin: 1,
  },
  actionDiv: {
    textAlign: 'center',
  },
};